import React, { useState } from "react";
import "./Careers.css";

const Careers = () => {
  const [jobs, setJobs] = useState([
    {
      jobName: "English Teacher",
      classToTeach: "Grade 8-10",
      subject: "English",
      qualification: "M.A. B.Ed",
      experience: "5+ years",
      salary: "not disclosed",
    },
    {
      jobName: "PET",
      classToTeach: "Grade 1-10",
      subject: "Physical Education",
      qualification: "B.P.Ed",
      experience: "5+ years",
      salary: "not disclosed",
    },
    {
      jobName: "Hindi Teacher",
      classToTeach: "Grade 8-10",
      subject: "Hindi",
      qualification: "HPT",
      experience: "5+ years",
      salary: "not disclosed",
    },
  ]);

  const renderVacancyStatus = () => {
    if (jobs.length === 0) {
      return <p>No Vacancies</p>;
    } else {
      return <p>Vacancies Available</p>;
    }
  };

  return (
    <div className="careers-container">
      <h2>Career Opportunities</h2>
      {renderVacancyStatus()}
      <div className="careers-card">
        <table>
          <thead>
            <tr>
              <th>Job Name</th>
              <th>Class</th>
              <th>Subject</th>
              <th>Qualification</th>
              <th>Experience</th>
              <th>Salary</th>
            </tr>
          </thead>
          <tbody>
            {jobs.map((job, index) => (
              <tr key={index}>
                <td>{job.jobName}</td>
                <td>{job.classToTeach}</td>
                <td>{job.subject}</td>
                <td>{job.qualification}</td>
                <td>{job.experience}</td>
                <td>{job.salary}</td>
              </tr>
            ))}
          </tbody>
        </table>
        <p className="email-info">
          📧 Mail your resumes to: <strong>vdprmhs1985@gmail.com</strong>
        </p>
      </div>
    </div>
  );
};

export default Careers;
